module.exports = __webpack_public_path__ + "img/pf.ae41fa8c.svg";